/* eslint-disable no-undef */
const defaultComponentName = 'googleanalytics';
const Plugin = {
  install(Vue, options = {}) {
    const vue = Vue;
    if (this.installed) return;
    this.installed = true;
    this.defaultComponentName = options.defaultComponentName || defaultComponentName;

    vue.prototype.$googleanalytics = {
      track() {
        if (window[`ga-disable-${process.env.VUE_APP_GOOGLE_ANALYTICS}`] || options.disabled) return;
        gtag('config', options.id, {
          page_path: options.router.currentRoute.path,
        });
      },
      event(name, data) {
        if (window[`ga-disable-${options.id}`] || options.disabled) return;
        window.gtag('event', name, data);
      },
      init() {
        if (window[`ga-disable-${options.id}`] || options.disabled) return;
        window.dataLayer = window.dataLayer || [];
        // eslint-disable-next-line
        window.gtag = function () {
          // eslint-disable-next-line prefer-rest-params
          window.dataLayer.push(arguments);
        };
        gtag('js', new Date());
        gtag('config', options.id, {
          page_path: options.router.currentRoute.path,
        });
      },
      disable() {
        window[`ga-disable-${options.id}`] = true;
      },
    };

    vue.prototype.$googleanalytics.init();
  },
};

export default Plugin;
